import { CanMatchFn } from '@angular/router';

import { RequestAccessDataService } from '../../modules/request-access/services/request-access-data.service';
import { createDataAccessGuard } from './data-access-guard.factory';

/**
 * Guards the request-access route:
 * - Redirects logged-in users to the dashboard.
 * - Redirects to the login page if no user data is stored
 *   (e.g. the user navigated directly to /request-access without going
 *   through Auth0 first).
 */
export const RequestAccessGuard: CanMatchFn = createDataAccessGuard(
  RequestAccessDataService,
  (dataService) => dataService.hasUserData(),
);
